import script from "./SectionSponsors.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionSponsors.vue?vue&type=script&setup=true&lang=js"

import "./SectionSponsors.vue?vue&type=style&index=0&id=4da15876&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4da15876"]])

export default __exports__